module.exports = __webpack_public_path__ + "static/img/img26.308bb1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/images/img26.png
// module id = 8fko
// module chunks = 1